import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { Helmet } from 'react-helmet';

const Hosting = () => {
  const features = [
    {
      icon: FiIcons.FiMail,
      title: 'Correos Ilimitados',
      description: 'Crea todas las cuentas de correo que necesites, cada una con 2 GB de espacio y acceso desde cualquier dispositivo.'
    },
    {
      icon: FiIcons.FiTrendingUp,
      title: 'Flexibilidad sin Sorpresas',
      description: '¿Tu web crece? Ampliamos tu espacio y recursos sin coste adicional. Nos adaptamos a ti para que nunca te quedes corto.'
    },
    {
      icon: FiIcons.FiUsers,
      title: 'Soporte Técnico Cercano',
      description: 'Si tienes un problema, hablas con nosotros en Tenerife. Sin tickets interminables ni respuestas automáticas.'
    }
  ];

  const benefits = [
    'Servidores rápidos y optimizados',
    'Cuentas de correo ilimitadas',
    '2 GB de espacio por buzón',
    'Flexibilidad para ampliar recursos',
    'Soporte técnico real desde Tenerife'
  ];

  return (
    <div className="py-16 relative">
      <Helmet>
        <title>Hosting Profesional en Tenerife | VGBComputers</title>
        <meta name="description" content="Consigue el mejor hosting para tu negocio en Tenerife por 180€/año. Incluye correos ilimitados y soporte técnico local real. ¡Contrata ahora!" />
      </Helmet>

      <div className="max-w-7xl mx-auto px-4">
        {/* Hero Section */}
        <section className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Hosting Confiable con Soporte Real desde Tenerife
          </h1>
          <p className="text-xl text-gray-600 mb-8 max-w-4xl mx-auto">
            Deja de pelear con la tecnología. Nuestro plan de hosting anual te da la velocidad y la seguridad que necesitas, con el respaldo de un equipo técnico local que de verdad te ayuda.
          </p>
          <Link 
            to="/contacto?servicio=hosting"
            className="inline-block bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-blue-700 transition-colors shadow-lg"
          >
            Contratar Hosting Ahora
          </Link>
        </section>

        {/* Características Clave */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-center mb-12">
            Todo lo que tu Negocio Necesita
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {features.map((feature, index) => (
              <div key={index} className="bg-white p-6 rounded-lg shadow-lg text-center">
                <SafeIcon icon={feature.icon} className="h-12 w-12 text-blue-600 mb-4 mx-auto" />
                <h3 className="text-xl font-semibold mb-3">{feature.title}</h3>
                <p className="text-gray-600">{feature.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Precio y Plan - TODO CENTRADO */}
        <section className="bg-gradient-to-r from-blue-50 to-blue-100 rounded-2xl p-8 md:p-12 text-center">
          <h2 className="text-3xl font-bold mb-6 text-center">Plan Hosting Anual VGB</h2>
          <div className="text-5xl font-bold text-blue-600 mb-2 text-center">180 €</div>
          <p className="text-gray-600 mb-8 text-center">+ IGIC</p>
          
          <div className="max-w-2xl mx-auto mb-8">
            <ul className="space-y-3 text-center">
              {benefits.map((benefit, index) => (
                <li key={index} className="flex items-center justify-center">
                  <SafeIcon icon={FiIcons.FiCheck} className="h-5 w-5 text-green-500 mr-3 flex-shrink-0" />
                  <span className="text-gray-700">{benefit}</span>
                </li>
              ))}
            </ul>
          </div>

          <Link 
            to="/contacto?servicio=hosting"
            className="inline-block bg-blue-600 text-white px-10 py-4 rounded-lg font-semibold text-lg hover:bg-blue-700 transition-colors shadow-lg"
          >
            Contratar Hosting Ahora
          </Link>
        </section>

        {/* Sección adicional de confianza */}
        <section className="mt-16 text-center">
          <h2 className="text-2xl font-semibold mb-8">¿Por qué elegir nuestro hosting?</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="flex flex-col items-center">
              <SafeIcon icon={FiIcons.FiZap} className="h-8 w-8 text-blue-600 mb-2" />
              <h3 className="font-semibold">Velocidad</h3>
              <p className="text-gray-600 text-sm">Servidores optimizados</p>
            </div>
            <div className="flex flex-col items-center">
              <SafeIcon icon={FiIcons.FiShield} className="h-8 w-8 text-blue-600 mb-2" />
              <h3 className="font-semibold">Seguridad</h3>
              <p className="text-gray-600 text-sm">Protección avanzada</p>
            </div>
            <div className="flex flex-col items-center">
              <SafeIcon icon={FiIcons.FiClock} className="h-8 w-8 text-blue-600 mb-2" />
              <h3 className="font-semibold">Disponibilidad</h3>
              <p className="text-gray-600 text-sm">99.9% uptime</p>
            </div>
            <div className="flex flex-col items-center">
              <SafeIcon icon={FiIcons.FiHeadphones} className="h-8 w-8 text-blue-600 mb-2" />
              <h3 className="font-semibold">Soporte Local</h3>
              <p className="text-gray-600 text-sm">Desde Tenerife</p>
            </div>
          </div>
        </section>
      </div>

      {/* Botón para volver arriba */}
      <button 
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className="fixed bottom-6 right-6 bg-blue-600 text-white p-3 rounded-full shadow-lg hover:bg-blue-700 transition-all z-50"
        aria-label="Volver arriba"
      >
        <SafeIcon icon={FiIcons.FiArrowUp} className="h-6 w-6" />
      </button>
    </div>
  );
};

export default Hosting;